export const phoneRegex = /^(?:(?:\+\d{1,3}-?)?(\d+-?)*\d+|\d+)?$/;
export const onlyPhoneCharsRegex = /^[0-9+-]+$/;
export const onlyLettersAndSpacesRegex = /^[A-Za-z\s]+$/;
export const linkRegex = /(?:https?:\/\/|www\.)[^\s]+/g; 